import Heading from 'components/heading/Heading';
import RichText from 'components/rich-text/RichText';

import { IRichTextWithTitle } from 'source/NFR.types';

// NOTE: headingLevelOffset is intended to be used by the backend only, as a way to describe the semantic relationships between blocks without having to know what the actual heading levels are.
const RichTextWithTitle: React.FC<IRichTextWithTitle> = ({ headingLevel, headingLevelOffset, htmlId, text, title }) => (
  <div className={'rich-text-with-title'}>
    {title && (
      <div data-epi-type="title">
        <Heading id={htmlId} level={headingLevel} levelOffset={headingLevelOffset}>
          {title}
        </Heading>
      </div>
    )}
    <div data-epi-type="content">
      <RichText {...text} />
    </div>
  </div>
);

RichTextWithTitle.displayName = 'RichTextWithTitle';

export default RichTextWithTitle;
